import { createContext, ReactNode } from "react"
import { useSelector } from "react-redux"
import { RootState } from "../store"

export interface AuthContextType {
  isAuth: boolean;
  toggle: () => void;
  user: any;
}

const defaultAuthContext: AuthContextType = {
  isAuth: false,
  toggle: () => { },
  user: null,
};

export const AuthContext = createContext<AuthContextType>(defaultAuthContext);

interface AuthContextProviderProps {
  children: ReactNode;
}

function AuthContextProvider({ children }: AuthContextProviderProps) {
  // Derive auth state from Redux store so dummy login is reflected everywhere
  const reduxUser = useSelector((state: RootState) => state.auth.user);
  const isAuth = !!reduxUser;

  return (
    <AuthContext.Provider value={{ toggle: () => { }, isAuth, user: reduxUser }}>
      {children}
    </AuthContext.Provider>
  )
}
export default AuthContextProvider